/*jshint esversion: 6 */
import CXMApiClient from "../CXMApiClient";
import { csv } from "../../lib/utilities/HelperFunctions";

function initialState() {
  return {
    hideUnclaimedStatus: false
  };
}

const state = initialState();

const getters = {};

const actions = {
  getVOIMakes(context, payload) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      let scope = payload.accountPlatformIds;

      client
        .ProcessRequest("post", "/vehicle/makes/search", payload)
        .then(response => {
          resolve(response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getEngagedSummary(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      let filter;
      filter = request.filter;
      filter.pagination = request.Pagination;
      client
        .ProcessRequest(
          "post",
          "/api/Activity/summary/engaged",
          filter,
          request.scope
        )
        .then(response => {
          return resolve(response.data.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getShowroomAppointmentsSummary(context, request) {
    return new Promise(async (resolve, reject) => {
      if (!request.scope || request.scope.length == 0) {
        return resolve(null);
      }
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/calendarevent/appointment/counts",
          request.filter,
          request.scope
        )
        .then(response => {
          return resolve(response.data.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getShowroomActivitySummary(context, request) {
    return new Promise(async (resolve, reject) => {
      if (!request.scope || request.scope.length == 0) {
        return resolve(null);
      }
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/Activity/summary/showroom_activity",
          request.filter,
          request.scope
        )
        .then(response => {
          return resolve(response.data.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getLeadData(context, request) {
    return new Promise(async (resolve, reject) => {
      if (!request.scope || request.scope.length == 0) {
        return resolve(null);
      }
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/CrmLead/manager_dashboard/lead_count",
          request.filter,
          request.scope
        )
        .then(resp => {
          if (resp && resp.data) {
            let response = resp.data.data;
            context.commit(
              "updateUnclaimedDisplayStatus",
              response ? !response.claimLeadsEnabled : true
            );
            return resolve(resp.data.data);
          } else reject(resp);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getDeliveryActivityData(context, request) {
    return new Promise(async (resolve, reject) => {
      if (!request.scope || request.scope.length == 0) {
        return resolve(null);
      }
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/Activity/summary/delivery_activity",
          request.filter,
          request.scope
        )
        .then(response => {
          return resolve(response.data.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getDeliveryAppointmentsData(context, request) {
    return new Promise(async (resolve, reject) => {
      if (!request.scope || request.scope.length == 0) {
        return resolve(null);
      }
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/Activity/summary/delivery_appointments",
          request.filter,
          request.scope
        )
        .then(response => {
          return resolve(response.data.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  getTouchPointSummary(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "post",
          "/api/touchpoint/activity/summary",
          request,
          request.accountPlatformIds
        )
        .then(response => {
          if (response && response.data) {
            resolve(response.data);
          } else reject(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  async exportShowroomLog(context, request) {
    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "post",
      "/api/touchpoint/activity/export/summary",
      request
    );
    if (response && response.data && response.status == 200) {
      // let replaceFalse = response.data.replaceAll("False", "No");
      // let replaceTrue = replaceFalse.replaceAll("True", "Yes");
      // response.data = replaceTrue;
    }
    return response ? csv.processCSV(response) : null;
  },
  updateTouchPointItemStatus: function(context, request) {
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      client
        .ProcessRequest(
          "POST",
          "/api/contact_touchpoint/" +
            request.touchpoint_slug +
            "/items/" +
            request.touchpoint_item_slug +
            "/" +
            request.requestType,
          request.postRequest,
          request.scope ? [request.scope] : []
        )
        .then(response => {
          if (response && response.data) {
            resolve(response.data);
          }
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
  async getContactTagsCount(context, request) {
    let response = await new CXMApiClient()
      .ProcessRequest("POST", "/crm/GetContactTagCounts", request)
      .catch(ex => {
        return null;
      });
    return response && response.data ? response.data : null;
  },
  async getContactTagDetails(context, request) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      "/crm/GetContactTagDetails",
      request
    );
    return response && response.data ? response.data : null;
  },
  async removeTagForCustomer(context, request) {
    let response = await new CXMApiClient().ProcessRequest(
      "POST",
      `/crm/RemoveContactTag?contactId=${request.contactId}&tagId=${request.tagId}`
    );
    return response && response.data ? response.data : null;
  }
};

const mutations = {
  updateUnclaimedDisplayStatus: function(state, data) {
    state.hideUnclaimedStatus = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/Dashboards.js